import React from "react";
import "./AwardsSection.css";

const awards = [
  {
    title: "Indian Achievers’ Award 2023",
    subtitle: "Business Leadership",
    image: "/assets/images/Awards/award1.png",
  },
  {
    title: "Indian Achievers’ Award 2022",
    subtitle: "Business Leadership",
    image: "/assets/images/Awards/award2.png",
  },
  {
    title: "Indian Achievers’ Award 2021",
    subtitle: "Young Entrepreneur",
   image: "/assets/images/Awards/award3.png",
  },
  {
    title: "Indian Achievers’ Award 2021",
    subtitle: "For Young Entrepreneur",
    image: "/assets/images/Awards/award4.png",
  },
];

const AwardsSection = () => {
  return (
    <section className="awards-section">
      <div className="awards-container">
        <h2 className="awards-title">Achievements & Awards</h2>

        <div className="awards-grid">
          {awards.map((award, index) => (
            <div className="award-card" key={index}>
              <div className="award-image">
                <img src={award.image} alt={award.title} />
              </div>

              <div className="award-info">
                <h3>{award.title}</h3>
                <span>{award.subtitle}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AwardsSection;
